import { css } from "@emotion/react";

// MIT License

// Copyright (c) 2020 Vineeth.TR

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

const EyesCss = css`
    position: relative;
    width: 108px;
    display: flex;
    justify-content: space-between;
    &::after,
    &::before {
        content: "";
        display: inline-block;
        width: 48px;
        height: 48px;
        background-color: #fff;
        background-image: radial-gradient(
            circle 14px,
            #0d161b 100%,
            transparent 0
        );
        background-repeat: no-repeat;
        border-radius: 50%;
        animation: eyeMove 5s infinite;
    }
    @keyframes eyeMove {
        0%,
        12.5% {
            background-position: -15px 0px;
        }
        12.5%,
        37.5% {
            background-position: 15px 0px;
        }
        37.5%,
        62.5% {
            background-position: 0px 15px;
        }
        62.5%,
        87.5% {
            background-position: 0px -15px;
        }
        87.5%,
        100% {
            background-position: -15px 0px;
        }
    }
    @keyframes blink {
        0%,
        10%,
        12%,
        20%,
        22%,
        40%,
        42%,
        60%,
        62%,
        70%,
        72%,
        90%,
        92%,
        98%,
        100% {
            height: 48px;
        }
        11%,
        21%,
        41%,
        61%,
        71%,
        91%,
        99% {
            height: 18px;
        }
    }
`;

const Eyes = () => {
    return (
        <div css={{ height: 48 }}>
            <span css={EyesCss} />
        </div>
    );
};

export { Eyes };
